class templateIndexJS {
    constructor() {
        this.headerSlider();
    }

    headerSlider(){
        var swiper_main = new Swiper('[data-header-slider]', {
            observer: true,
            observeParents: true,
            loop: false,
            grabCursor: true,
            autoHeight: true,
            speed: 800,
            autoplay: {
                delay: 4000,
                disableOnInteraction: true
            },
            pagination: {
                el: ".hero-pagination",
                clickable: true
            },
            on: {
                slideChange: function (e) {
                    const index_currentSlide = e.realIndex;
                    const currentSlide = e.slides[index_currentSlide]
                    let text =  currentSlide.dataset.linkTxt;
                    let url =  currentSlide.dataset.linkUrl;
                    document.querySelector('[data-slider-txt]').innerHTML = text;
                    document.querySelector('[data-slider-txt]').href = url;
                },
            }
        });
        // swiper_main.on('slideChange', function () {
        //     const index_currentSlide = swiper_main.realIndex;
        //     const currentSlide = swiper_main.slides[index_currentSlide]

        //     let text =  currentSlide.dataset.linkTxt;
        //     let url =  currentSlide.dataset.linkUrl;
        //     document.querySelector('[data-slider-txt]').innerHTML = text;
        //     document.querySelector('[data-slider-txt]').href = url;
        // });
    }
}

typeof templateIndexJS !== 'undefined' && new templateIndexJS();

 


